module.exports = __webpack_public_path__ + "media/staff/gordon2-e4876c2b.jpg";